import React from 'react';
import { Paper, Grid, Typography } from '@material-ui/core';

// Récapitulatif des totaux de la semaine
export default function RecapitulatifCard({ classes, isMobile, totalSemaine, totalSemaineBrut, totalDeplacementsBruts, heuresSup }) {
    const align = isMobile ? 'center' : 'left';
    return (
        <Paper className={classes.recapCard}>
            <Typography variant="h6" style={{ fontWeight: 'bold', color: '#2b6cb0', marginBottom: 16, textAlign: align }}>
                Récapitulatif de la semaine
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4} style={{ textAlign: align }}>
                    <Typography variant="body2" color="textSecondary">Total brut (jours + déplacements)</Typography>
                    <Typography variant="h5" style={{ fontWeight: 800, color: '#2d3748' }}>{totalSemaineBrut} h</Typography>
                </Grid>
                <Grid item xs={12} sm={4} style={{ textAlign: align }}>
                    <Typography variant="body2" color="textSecondary">Dont déplacements déclarés</Typography>
                    <Typography variant="h5" style={{ fontWeight: 800, color: '#2b6cb0' }}>{totalDeplacementsBruts} h</Typography>
                </Grid>
                <Grid item xs={12} sm={4} style={{ textAlign: align }}>
                    <Typography variant="body2" color="textSecondary">Trajet domicile/travail déduit</Typography>
                    <Typography variant="h5" style={{ fontWeight: 800, color: '#718096' }}>- 1h30</Typography>
                </Grid>
                <Grid item xs={12} sm={4} style={{ textAlign: align }}>
                    <Typography variant="body2" color="textSecondary">Total heures travaillées (net)</Typography>
                    <Typography variant="h5" style={{ fontWeight: 800, color: '#2d3748' }}>{totalSemaine} h</Typography>
                </Grid>
                <Grid item xs={12} sm={4} style={{ textAlign: align }}>
                    <Typography variant="body2" color="textSecondary">Heures au-delà de 39h</Typography>
                    <Typography variant="h5" style={{ fontWeight: 800, color: parseFloat(heuresSup) > 0 ? '#d69e2e' : '#718096' }}>{heuresSup} h</Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}

